export const environment = {
	production: false,
	googleClientId: '1015894346611-6iuifk3vk2ddndp1ub7h9s1k2skeubhg.apps.googleusercontent.com',
	razorPayKey: 'rzp_test_RXHOZgSEn19uRp',
	baseUrl: 'https://edtech.almmai.com/userManagement',
	baseRedirectUrl: 'https://mm-stage-b2c.acelucid.com/auth-callback',
	baseRedirectCalanderUrl: 'https://mm-stage-b2c.acelucid.com/student-dashboard/mentors',
	classroomId: 693,
	FIREBASE_VAPID_KEY: 'BBiMqNP2Dul8DuDfy5QdVQPeQGSYthBQrDL_lA-nIlGvvwV_MpArskahOo1TAqI_D5jQcyiDMfwGqMA8G8n_oNE',
	ONESIGNAL_APP_ID: '44d3d78b-257f-4a5c-a7a0-42a8b2a1e437',
	FIREBASE_API_KEY: 'AIzaSyDS830nyEdNIYqTarctSatpUzUZ518Loes',
	FIREBASE_AUTH_DOMAIN: 'mind-mentor-fe138.firebaseapp.com',
	FIREBASE_PROJECT_ID: 'mind-mentor-fe138',
	FIREBASE_STORAGE_BUCKET: 'mind-mentor-fe138.firebasestorage.app',
	FIREBASE_MESSAGING_SENDER_ID: '439947253707',
	FIREBASE_APP_ID: '1:439947253707:web:6762d52e2264aefca8084e',
	FIREBASE_MEASUREMENT_ID: 'G-WLQ2YB07NX',
	classroomApiUrl: 'https://edtech.almmai.com/classroomManagement',
	memberApiUrl: 'https://edtech.almmai.com/memberManagement',
	courseApiUrl: 'https://edtech.almmai.com/courseManagement',
	quizApiUrl: 'https://edtech.almmai.com/quizManagement',
	dashboardUrl: 'https://edtech.almmai.com/dashboard',
	studentApiUrl: 'https://edtech.almmai.com/studentManagement',
	adminApiUrl: 'https://edtech.almmai.com/adminManagement',
	materialApiUrl: 'https://edtech.almmai.com/materialManagement',
	announcementApiUrl: 'https://edtech.almmai.com/announcement',
	notificationApiUrl: 'https://edtech.almmai.com/notification',
	usagePlanApiUrl: 'https://edtech.almmai.com/usageManagement',
	adminDashboardUrl: 'https://edtech.almmai.com/adminManagement',
	departmentApiUrl: 'https://edtech.almmai.com/batchManagement',
	batchApiUrl: 'https://edtech.almmai.com/batchManagement',
	aiInterviewManagementUrl: 'https://edtech.almmai.com/aiInterviewManagement',
	aiScreeningInterviewManagementUrl: 'https://edtech.almmai.com/aiScreeningInterviewManagement',
	mentorApiUrl: 'https://edtech.almmai.com/mentor',
	paymentApiUrl: 'https://edtech.almmai.com/payment',
	studentCourseApiUrl: 'https://edtech.almmai.com/studentCourse',
	placementPreparationUrl: 'https://edtech.almmai.com/placementPreparation',
	roadMapApiUrl: 'https://edtech.almmai.com/roadmap',
	onboardingApiUrl: 'https://edtech.almmai.com/onboarding',
	resumeApiUrl: 'https://edtech.almmai.com/resumeBuilder',
	companyApiUrl: 'https://edtech.almmai.com/company',
	hrmsApiUrl: 'https://edtech.almmai.com/api',
	jobApiUrl: 'https://edtech.almmai.com/jobs',
	candidateApiUrl: 'https://edtech.almmai.com/candidates',
	StudentJobApiUrl: 'https://edtech.almmai.com/student-jobs',
	proctoringApiUrl: 'https://edtech.almmai.com/api/v1',
	leadsApiUrl: 'https://edtech.almmai.com/leads',
	mockInterview: 'https://edtech.almmai.com/api/ai/student/practice-history',
	collegeManagementUrl: 'https://edtech.almmai.com/collegeManagement',
	collegePortalApiUrl: 'https://edtech.almmai.com/collegePortal',

	authEndpoints: {
		newSignup: '/register',
		signup: '/signup',
		verifyUserOtp: '/verifyUserOtp',
		resendOtp: '/resend-otp',
		assignRoles: '/assignRoles',
		getRoles: '/getRoles',
		signin: '/signin',
		refreshToken: '/refresh',
		forgotPassword: '/forgot-password',
		verifyResetOtp: '/verify-reset-otp',
		resetPassword: '/reset-password',
		logout: '/logout',
		googleAuth: '/auth/google',
		userDetails: '/userDetails',
		teacherInvite: '/teacherInvite',
		userEditProfile: '/updateUserProfile',
		invitation: '/invitation',
	},

	teacherDashboardEndpoints: {
		teacherDashboard: '/teacher-dashboard',
		studentDashboard: '/student-dashboard'
	},

	superAdminDashboardEndpoints: {
		superAdminDashboard: '/getDashboardStats',
		adminTeacherInvite: '/invites',
	},

	materialUploadEndpoints: {
		uploadMaterial: '/uploadMaterial',
	},

	adminDashboardEndpoints: {
		adminDashboard: '/dashboard-info',
		adminStats: '/admin/dashboard/stats',
		inviteTeacher: '/inviteTeacher',
		inviteStudent: '/inviteStudent',
		getDesignations: '/admin/getDesignations',
		getTeachersByFilter: '/admin_teachers',
		deleteUser: '/deleteUser',
		deleteInvite: '/deleteInvite',
		searchTeachers: '/search_teachers',
		bulkInviteStudents: '/bulkInviteStudents',
		bulkInviteTeachers: '/bulkInviteTeachers',
		validateTemplate: '/admin/templates',
		getStudentsByFilter: '/admin_students',
		searchStudents: '/search',
		dashboardOverview: '/dashboard/overview',
		dashboardEntities: '/dashboard/entities',
	}
};